<template>
    <div>
        <div v-for="(item,index) in routes" :key="index">
            <div v-if="!item.hidden&&item.noDropdown">
                <a v-if='item.type==="window"' class="menu-indent" @click="openUrl(item.path)">
                    <li role="menuitem" tabindex="-1" class="el-menu-item" style="background-color: rgb(255, 255, 255);">
                        <wscn-icon-svg v-if='item.icon' :icon-class="item.icon"/>
                        {{ item.name }}
                    </li>
                </a>

                <router-link v-if='item.type!=="window"' class="menu-indent" :to="item.path">
                    <el-menu-item :index="item.path">
                        <wscn-icon-svg v-if='item.icon' :icon-class="item.icon"/>
                        {{ item.name }}
                    </el-menu-item>
                </router-link>
            </div>
            <el-submenu :index="item.name" v-if="!item.noDropdown&&!item.hidden">
                <template slot="title">
                    <wscn-icon-svg v-if='item.icon' :icon-class="item.icon"/>
                    {{ item.name }}
                </template>
                <div v-for="(child ,childIndex) in item.children" v-if="!child.hidden && child.yon=='Y'" :key="childIndex">
                    <sidebar-item class='menu-indent' v-if='child.children&&child.children.length>0' :routes='[child]'></sidebar-item>
                    <a v-if='child.type==="window"' class="menu-indent" @click="openUrl(child.path)">
                        <li role="menuitem" tabindex="-1" class="el-menu-item" style="padding-left: 40px; background-color: rgb(255, 255, 255);">
                            {{ child.name }}
                        </li>
                    </a>
                    <router-link v-if='child.type!=="window"' class="menu-indent" :to="item.path+'/'+child.path">
                        <el-menu-item :index="item.path+'/'+child.path">
                            {{ child.name }}
                        </el-menu-item>
                    </router-link>
                </div>
            </el-submenu>
        </div>
    </div>
</template>
<script>

import {globalConfig} from "static/config"

export default {
    name: 'SidebarItem',
    props: {
        routes: {
            type: Array
        }
    },
    methods: {
        openUrl(path) {
            if (!path.startsWith('http')) {
                path = globalConfig.FONT_PROXY_PATH + "/#/" + path;
            }
            window.open(path)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wscn-icon {
    margin-right: 10px;
}

.hideSidebar .menu-indent {
    display: block;
    text-indent: 10px;
}

.el-menu-item:hover {
    background-color: #cccccc !important;
}
</style>



// WEBPACK FOOTER //
// SidebarItem.vue?3e8f442a